import React from "react";
import { OrganizationStatus } from "../../models/enumerations/organization-status";
import { useTranslation } from 'react-i18next';

interface OrganizationStatusBadgeProps {
    status?: OrganizationStatus,
    expired?: boolean,
}

/**
 * A small badge representing the status of an organization.
 */
export const OrganizationStatusBadge: React.FC<OrganizationStatusBadgeProps> = (props) => {
    const {
        expired,
        status,
    } = props;
    const { t } = useTranslation();

    const commonStyles = {
        fontSize: '10px',
        lineHeight: '11px',
        width: 'fit-content',
        padding: '6px 8px',
        borderRadius: '4px'
    }

    const activeBadge = (
        <span
            style={{
                background: 'rgba(0, 223, 188, 1)',
                ...commonStyles,
            }}
        >
            {t('organization.edit.statuses.active')}
        </span>
    );

    const expiredBadge = (
        <span
            style={{
                background: 'rgba(231, 81, 79, 1)',
                color: 'white',
                ...commonStyles,
            }}
        >
            {t('organization.edit.statuses.expired')}
        </span>
    );

    const deactivatedBadge = (
        <span
            style={{
                background: 'rgba(18, 22, 34, 1)',
                color: 'white',
                ...commonStyles,
            }}
        >
            {t('organization.edit.statuses.deactivated')}
        </span>
    );

    if (status === OrganizationStatus.Deactivated) {
        return deactivatedBadge;
    }

    if (status === OrganizationStatus.Active) {
        return activeBadge;
    }

    if (status === OrganizationStatus.Expired || expired === true) {
        return expiredBadge;
    }

    return null;
};
